<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
[value]="organisme?.classificationOrganisme" 
[label]="step1.getclassificationorganisme"
[type]="'select'"
[autoCompleteType]="'CLASSIFICATIONORGANISME'"
[autoCompleteTypeIndex]="0" [rule]="'pattern_26'"
[optionsWithCode]="optionsSelect"
[typeSelect]="optionsSelectType"
[name]="getUid()+'_SepAtt_classificationOrganisme'">
</app-form-input>

<span class="d-block">{{ step1.getspan2 | translate }}</span>

<app-type-pers  [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled" [formName]="formName"
[personnePhysique]="organisme?.correspondantPRM"></app-type-pers>

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
[value]="organisme?.acheteurPublic" 
[label]="step1.getacheteurpublic"
[type]="'text'"
[rule]="'pattern_31|minSize_1|maxSize_400'"
[name]="getUid()+'_SepAtt_acheteurPublic'">
</app-form-input>

<app-type-adresse  [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
[adr]="organisme?.adr"></app-type-adresse>

<app-type-coord  [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled" [formName]="formName"
[coord]="organisme?.coord"></app-type-coord>

<!-- URL profil acheteur autre que DIVE_AT -->
<app-form-input *ngIf="formName !== 'DIVE_AT'" 
[parentForm]="parentForm"
[disabled]="disabled"
[value]="organisme?.urlProfilAcheteur" 
[label]="step1.geturlprofilacheteur"
[type]="'text'"
[rule]="'pattern_28|maxSize_200'"
[name]="getUid()+'_SepAtt_urlProfilAcheteur'"
[errorMessage]="{'pattern' : 'ctr_568'}">
</app-form-input>

<!-- URL pouvoir adjudicateur -->
<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
[value]="organisme?.coord?.url" 
[label]="step1.geturl"
[type]="'text'"
[rule]="'maxSize_200|pattern_33'"
[errorMessage]="{'pattern' : 'ctr_7'}"
[name]="getUid()+'_SepAtt_url'">
</app-form-input>

<!-- URL profil acheteur pour DIVE_AT -->
<app-form-input *ngIf="formName === 'DIVE_AT'" 
[parentForm]="parentForm"
[disabled]="disabled"
[value]="organisme?.urlProfilAcheteur" 
[label]="step1.geturlprofilacheteur"
[type]="'text'"
[rule]="'pattern_28|maxSize_200'"
[name]="getUid()+'_SepAtt_urlProfilAcheteur'"
[errorMessage]="{'pattern' : 'ctr_568'}">
</app-form-input>